module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/production/production-testimonial-2-3a0e214b267d49823d5ffc7866ad4592.jpg";